import L from "leaflet";

const clusterSvg = (count: number) => {
  return `
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="25" cy="25" r="22" fill="#3B82F6" stroke="white" stroke-width="2"/>
      <text x="25" y="30" font-family="Arial" font-size="16" font-weight="bold" fill="white" text-anchor="middle">${count}</text>
    </svg>
  `;
};

const ClusterIcon = (cluster: L.MarkerCluster) => {
  const count = cluster.getChildCount();
  const html = clusterSvg(count);
  const iconSize = L.point(50, 50);

  return L.divIcon({
    html: html,
    className: "custom-cluster-icon",
    iconSize: iconSize,
    iconAnchor: L.point(iconSize.x / 2, iconSize.y / 2),
  });
};

export default ClusterIcon;
